import { AppState } from '../../app-state/app-state';
import { schoolAdapter } from '../reducers';
import { createSelector } from '@ngrx/store';
import { SchoolsState } from './schools.state';

export const getSchoolsState = (state: AppState) => state.schools;

export const getSchoolsCollection = schoolAdapter.getSelectors(getSchoolsState).selectAll;
export const getSchoolsEntities = schoolAdapter.getSelectors(getSchoolsState).selectEntities;

export const getLoadedSchools = createSelector(getSchoolsState, (state: SchoolsState) => state.loaded);

export const getSchoolSyncInfoData = createSelector(getSchoolsState, (state: SchoolsState) => state.syncInfo);

export const getCurrentSchoolId = createSelector(getSchoolsState, (state: SchoolsState) => state.currentSchoolId);

const getdidUpdate = createSelector(getSchoolsState, (state: SchoolsState) => state.didUpdate);

export const getCurrentSchool = createSelector(getSchoolsEntities, getCurrentSchoolId, (entities, id) => (id ? entities[id] : undefined));

/**
 * This value only changes to be defined after an update for a school is happens, and with any school change thereafter.
 *
 * @deprecated This selector is not very useful and only available for backwards compatibility.
 */
export const getCurrentUpdateSchool = createSelector(getSchoolsEntities, getCurrentSchoolId, getdidUpdate, (entities, id, didUpdate) =>
	didUpdate && id ? entities[id] : undefined
);

export const getGSuiteSyncInfoData = createSelector(getSchoolsState, (state: SchoolsState) => state.gSuiteInfo);

export const getSchoolCleverInfo = createSelector(getSchoolsState, (state: SchoolsState) => state.cleverInfo);

export const getSchoolClassLinkInfo = createSelector(getSchoolsState, (state: SchoolsState) => state.classLinkInfo);

export const getSyncLoading = createSelector(getSchoolsState, (state: SchoolsState) => state.syncLoading);

export const getSchoolsLength = schoolAdapter.getSelectors(getSchoolsState).selectTotal;
